import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { bussinesArea, bussinesAreaType } from '../../types/slices/bussinesAreaType'

const initialState: bussinesAreaType =
{
    status: ApiStatus.FETCHED,
    bussinesArea: [],
    bussinesAreaSelected: {} as bussinesArea,
    errorMessage: undefined,
    action: ''
}

const bussinesAreaSlice = createSlice({
    name: 'bussinesAreaSlice',
    initialState,
    reducers: {
        onFetchBussinesArea (state, { payload }: { payload: bussinesArea[]}) {
        state.status = ApiStatus.FETCHED
        state.bussinesArea = payload
        state.errorMessage = undefined
        },
        onSetSelectedBussinesArea (state, { payload }: { payload: bussinesArea }) {
        state.bussinesAreaSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
        state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
        state.action = payload
        },
    }
})

export const selectBussinesAreaState = (state: RootState) => state.bussinesAreaSlice
export default bussinesAreaSlice.reducer
export const {
    onFetchBussinesArea,
    onSetSelectedBussinesArea,
    changeStatus,
    setAction,
} = bussinesAreaSlice.actions
